<template>
  <div class="main-container">
    <slot name="bread"></slot>
    <div class="main-content clearfix">
      <div class="f-left questions">
        <el-scrollbar ref="scroll" style="height: calc(100vh - 148px)">
          <template v-for="ques in list">
            <Question
              :isFile="2"
              v-if="showQuestion[ques.index]"
              :class="{
                'question-sub-first': ques.parent_ques_stem && ques.is_sub_first,
                'question-sub-last': ques.parent_ques_stem && ques.is_sub_last,
                'question-sub': ques.parent_ques_stem,
              }"
              :key="ques.question_id"
              :ques="ques"
              :answer="answer"
              :readonly="true"
              :hasAnalysis="true"
              shotAnswerEditable
              :showOperate="false"
              from="analysis"
              :showAllParentStem="false"
              :autoMathJax="false"
            ></Question>
            <div v-else :id="ques.index" :key="ques.question_id"></div>
          </template>
          <div ref="placeholder"></div>
        </el-scrollbar>
      </div>
      <div
        ref="right"
        class="f-right"
        :style="{
          position: fixed ? 'fixed' : 'static',
          right: fixedRight + 'px',
          top: '70px',
        }"
      >
        <div class="answer-view">
          <div class="title">答题卡</div>
          <div class="legend">
            <span class="num num-1"></span>
            <span class="text">正确</span>
            <span class="num num-2"></span>
            <span class="text">错误</span>
            <span class="num num-3"></span>
            <span class="text">未作答</span>
            <span class="num num-4"></span>
            <span class="text">简答题作答</span>
          </div>
          <div class="nums">
            <template v-if="hasSection">
              <template v-for="item in scantron.list">
                <div class="section" :key="'section-' + item.id">
                  {{ item.name }}
                </div>
                <div :key="'nums-' + item.id">
                  <a
                    href="javascript:void(0)"
                    class="num"
                    :class="'num-' + ques.status"
                    v-for="ques in item.child"
                    :key="ques.sort"
                    @click="scrollTo(ques.sort)"
                  >
                    {{ ques.sort }}
                  </a>
                </div>
              </template>
            </template>
            <template v-else>
              <a
                href="javascript:void(0)"
                class="num"
                :class="'num-' + ques.status"
                :key="ques.sort"
                v-for="ques in scantron.list"
                @click="scrollTo(ques.sort)"
              >
                {{ ques.sort }}
              </a>
            </template>
          </div>
        </div>
        <div class="btn-retry" @click="goRepeat">重新练习</div>
      </div>
    </div>
    <LimitModal ref="limitModal" />
  </div>
</template>
<script>
import Question from '@/components/ques/Question';
export default {
  name: 'ExamAnalysis',
  components: {
    Question,
  },
  props: {
    reportType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      visible: false,
      questionType: '',
      answer: {},
      fixed: false,
      fixedRight: 0,
      scantron: { list: [] },
      section: {},
      showQuestion: {},
      ids: [],
      scrollbarWrap: null,
    };
  },
  computed: {
    hasSection() {
      if (this.scantron.list.length == 0) {
        return false;
      }
      return !!this.scantron.list[0].child;
    },
  },
  async created() {
    this.scantron = await this.$http.post('/api/app/practice/scantron', {
      report_id: this.$route.query.id,
      type: 1,
      status: this.$route.query.type,
    });
    this.scantron.list.forEach((t) => {
      if (!t.child) {
        return;
      }
      t.child.forEach((ques, index) => {
        if (index == 0) {
          this.$set(this.section, ques.sort, {
            name: t.name,
            introduce: t.introduce,
          });
        }
      });
    });
    let data = await this.$http.post('/api/app/practice/analysis', {
      report_id: this.$route.query.id,
      type: this.$route.query.type,
    });
    let parent_id = '';
    console.log(data);
    data.forEach((ques, index) => {
      if (ques.parent_id != parent_id) {
        parent_id = ques.parent_id;
        ques.is_sub_first = true;
        if (index > 0) {
          data[index - 1].is_sub_last = true;
        }
      }
      ques.index = index + 1;
      if (ques.ques_type != 5 && ques.ques_option && typeof ques.ques_option === 'string') {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        let id = ques.ques_option.filter((o) => o.is_right == 1)[0].id;
        this.$set(this.answer, ques.question_id, id);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        let ids = [];
        ques.ques_option
          .filter((o) => o.is_right == 1)
          .forEach((o) => {
            ids.push(o.id);
          });
        this.$set(this.answer, ques.question_id, ids);
      } else if (ques.ques_type == 7) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.right_answer.map((item) => (Array.isArray(item) ? item.join('、') : item)),
        );
      }

      this.$set(this.showQuestion, ques.index, true);
      this.ids.push(ques.index);
    });

    this.list = data;
    this.$nextTick(async () => {
      this.showContent();
      let size = 20;
      let count = parseInt(this.ids.length / size);
      if (this.ids.length % size > 0) {
        count++;
      }
      for (let i = 0; i < count; i++) {
        let showIds = this.ids.slice(i * size, (i + 1) * size);
        setTimeout(() => {
          window.MathJax.typesetPromise(showIds.map((id) => '.question-' + id));
        }, 10);
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollbarWrap = this.$refs.scroll.$el.querySelector('.el-scrollbar__wrap');
      this.scrollbarWrap.addEventListener('scroll', this.showContent);
      document.addEventListener('scroll', this.setFixed);
      document.addEventListener('resize', this.setFixed);
    });
  },
  beforeDestroy() {
    this.scrollbarWrap.removeEventListener('scroll', this.showContent);
    document.removeEventListener('scroll', this.setFixed);
    document.removeEventListener('resize', this.setFixed);
  },
  methods: {
    async showContent() {
      let $ = window.$;
      let placeholderOffset = $(this.$refs.placeholder).offset();
      let height = this.$refs.scroll.$el.offsetHeight;

      if (placeholderOffset.top - 118 - 10 > height) {
        return;
      }
      let showId;
      for (let i = 0; i < this.ids.length; i++) {
        let id = this.ids[i];
        if (!this.showQuestion[id]) {
          showId = id;
          break;
        }
      }
      if (showId) {
        this.showQuestion[showId] = true;
        await this.$nextTick();
        await window.MathJax.typesetPromise(['.question-' + showId]);
        this.showContent();
      }
    },
    setFixed() {
      let $ = window.$;
      if ($(window).scrollTop() + 84 > 203) {
        this.fixed = true;
        this.fixedRight = ($(window).width() - 1200) / 2;
        if (this.fixedRight < 0) {
          this.fixedRight = 0;
        }
      } else {
        this.fixed = false;
      }
    },
    async scrollTo(id) {
      if (!this.showQuestion[id]) {
        this.showQuestion[id] = true;
        await this.$nextTick();
        await window.MathJax.typesetPromise(['.question-' + id]);
      }
      let $ = window.$;
      let top = $('#' + id).offset().top + $(this.scrollbarWrap).scrollTop() - 118;
      $(this.scrollbarWrap).scrollTop(top);
      let ids = [];
      for (let i = 1; i < id; i++) {
        if (this.showQuestion[i]) {
          continue;
        }
        this.showQuestion[i] = true;
        ids.push(i);
      }
      await this.$nextTick();
      ids.forEach((i) => {
        setTimeout(async () => {
          await window.MathJax.typesetPromise(['.question-' + i]);
        }, 1);
      });
    },
    async goRepeat() {
      //重新练习，根据页面类型判断答题次数是否用完
      if (this.reportType && this.reportType == 'random') {
        //判断随机练习免费答题次数是否用完
        await this.$refs.limitModal.checkAnswer(1, '随机练习');
      } else if (this.reportType && this.reportType == 'special') {
        await this.$refs.limitModal.checkAnswer(3, '专项练习');
      } else if (this.reportType && this.reportType == 'package') {
        const is_can_do = this.scantron.is_can_do || '';
        if (is_can_do && is_can_do == 2) {
          //会员过期
          this.visible = true;
          this.questionType = '套卷练习';
          return;
        } else if (is_can_do && is_can_do == 3) {
          //判断有没有权限进入套卷练习
          this.$message.warning('您没有权限进入');
          return;
        }
      }
      this.$emit('goRepeat');
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 30px;
  .f-left {
    width: 890px;
  }
  .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
  }

  ::v-deep {
    .el-scrollbar__wrap {
      border-radius: 5px;
      overflow-x: hidden;
    }
    .el-scrollbar__thumb {
      background-color: #bfbfbf;
    }
    .question {
      border: none;
      border-radius: 5px;
      background-color: white;
      padding: 20px 34px 0 56px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    .question-sub:not(.question-sub-last) {
      margin-bottom: 0 !important;
    }
    .question-sub:not(.question-sub-first) {
      padding-top: 0 !important;
    }
  }
}
.section {
  .title {
    background-color: #f7f7f7;
    padding: 16px 25px;
    font-size: 18px;
    color: #262626;
    span {
      margin-right: 5px;
    }
  }
}
.section-name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 1;
  margin-bottom: 20px;
}
.section-introduce {
  font-size: 14px;
  color: rgba(128, 128, 128, 1);
  line-height: 1;
  margin-bottom: 20px;
}
.btn-retry {
  margin: 20px;
  height: 36px;
  background: $primary-color;
  border-radius: 5px;
  font-size: 14px;
  color: white;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  &:hover {
    background: $primary-color-hover;
  }
}
.answer-view {
  border: 1px solid rgba(233, 236, 236, 1);
  border-radius: 5px;
  margin: 19px 20px;
  .title {
    height: 40px;
    background: rgba(245, 245, 245, 1);
    line-height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    padding-left: 18px;
  }
  .nums {
    padding-left: 14px;
    max-height: calc(100vh - 70px - 48px - 19px - 40px - 85px - 56px);
    overflow-y: auto;
    .num {
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
    .section {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
      padding-top: 7px;
    }
  }
  .num {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    line-height: 28px;
    display: inline-block;
    text-align: center;
    border: 1px solid rgba(191, 191, 191, 1);
    border-radius: 3px;
    color: #333333;
    margin-bottom: 15px;
    margin-right: 13px;
    cursor: pointer;
    &.num-1 {
      background-color: #30c596;
      border-color: #30c596;
      color: white;
    }
    &.num-2 {
      background-color: #ff2d28;
      border-color: #ff2d28;
      color: white;
    }
    &.num-4 {
      background-color: #ef811e;
      border-color: #ef811e;
      color: white;
    }
  }
  .legend {
    display: flex;
    flex-wrap: wrap;
    padding: 21px 19px 6px 14px;
    align-items: center;
    .num {
      margin-right: 5px;
      width: 14px;
      height: 14px;
      border-radius: 2px;
      cursor: default;
    }
    .text {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
      margin-bottom: 15px;
      white-space: nowrap;
      &:nth-child(2) {
        margin-right: 26px;
      }
      &:nth-child(4) {
        margin-right: 26px;
      }
    }
  }
}
</style>
